import { render, staticRenderFns } from "./AccountDetailForm.vue?vue&type=template&id=5fd2f059&scoped=true&"
import script from "./AccountDetailForm.vue?vue&type=script&lang=js&"
export * from "./AccountDetailForm.vue?vue&type=script&lang=js&"
import style0 from "./AccountDetailForm.vue?vue&type=style&index=0&id=5fd2f059&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fd2f059",
  null
  
)

export default component.exports